import { IconLibrary } from '@product-framework/index';
import ServiceProviderLocationEdit from '../edit';
import ServiceProviderSkills from '../../Skills/index';
import SystemSettings from '../../SystemSettings/index';
import Performance from '../../Performance/index';
import Setup from '../../SetUp/index';
import ServiceArea from '../servicearea';
import { LOCATIONS_FORM_VIEW } from '../../../constants';
import LocationAvailability from '../../Availability/index';

const LocationStepperTabsConfig = ({
  userAccess,
  serviceAreaEnabled,
  formatMessage,
  hasAvailabilityFeature,
  hasSystemSettings,
  dispatchPurchased,
  claimsPurchased,
}) => {
  const tabs = [
    {
      id: LOCATIONS_FORM_VIEW.DETAILS,
      label: formatMessage({
        id: 'LOCATION_DETAILS',
        defaultMessage: 'Location Details',
      }),
      Component: ServiceProviderLocationEdit,
      Icon: IconLibrary.ServiceProviderSingleLocation,
    },
    {
      id: LOCATIONS_FORM_VIEW.SERVICEAREA,
      label: formatMessage({
        id: 'SERVICE_AREA',
        defaultMessage: 'Service Area',
      }),
      hasPermission: serviceAreaEnabled,
      Component: ServiceArea,
      Icon: IconLibrary.ServiceArea,
      statusKey: null,
    },
    {
      id: LOCATIONS_FORM_VIEW.SKILLS,
      hasPermission: dispatchPurchased,
      label: formatMessage({
        id: 'LOCATION_SKILLS',
        defaultMessage: 'Location Skills',
      }),
      Component: ServiceProviderSkills,
      Icon: IconLibrary.Skills,
    },
    {
      id: LOCATIONS_FORM_VIEW.SETUP,
      label: formatMessage({
        id: 'SETUP',
        defaultMessage: 'Setup',
      }),
      Component: Setup,
      Icon: IconLibrary.Setup,
    },
    {
      id: LOCATIONS_FORM_VIEW.SYSTEM_SETTINGS,
      hasPermission:
        (userAccess.isSA() || userAccess.isAdmin()) &&
        hasSystemSettings &&
        claimsPurchased,
      label: formatMessage({
        id: 'SYSTEM_SETTINGS',
        defaultMessage: 'System Settings',
      }),
      Component: SystemSettings,
      Icon: IconLibrary.SystemSetting,
    },
    {
      id: LOCATIONS_FORM_VIEW.PERFORMANCE,
      label: formatMessage({
        id: 'PERFORMANCE',
        defaultMessage: 'Performance',
      }),
      Component: Performance,
      Icon: IconLibrary.Performance,
    },
    {
      id: LOCATIONS_FORM_VIEW.AVAILABILITY,
      hasPermission: hasAvailabilityFeature,
      label: formatMessage({
        id: 'AVAILABILITY',
        defaultMessage: 'Availability',
      }),
      Component: LocationAvailability,
      Icon: IconLibrary.AvailabilitySchedular,
    },
  ];
  return tabs.filter(tab => tab.hasPermission !== false);
};

export default LocationStepperTabsConfig;
